module.exports = "/packs/media/images/icons/default_insurance-65cc94efc26eab67f621a5307421178f.png";